<!-- version 2021/06/14 -->
<template>
  <a href="" class="btn" @click="toggle">
    <i v-if="checked" class="fa fa-lg fa-check-square checked"></i>
    <i v-else class="fa fa-lg fa-check-square "></i>
    {{ title }}
  </a>
</template>

<script>
export default {
  props: {
    title: String,
    checked: Boolean,
    href: String,
  },
  data() {
    return {
      token: document
        .getElementsByName('csrf-token')[0]
        .getAttribute('content'),
    };
  },
  methods: {
    toggle(e) {
      e.preventDefault();
      $('#clinic-showable').submit();
    },
  },
};
</script>

<style lang="sass" scoped>
a
  background-color: #FFF !important
  color: #405E66 !important
  display: flex
  justify-content: center
  align-items: center
  i
    font-size: 24px
    margin-right: 10px
    color: rgba(0, 0, 0, 0.08)
    &.checked
      color: rgb(40, 195, 205)
</style>
